import { render, staticRenderFns } from "./IconMenuAlt2Outline.vue?vue&type=template&id=61db3b84"
import script from "./IconMenuAlt2Outline.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt2Outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports